var idCounter = 0;
/**
 * @deprecated use useUniqueId instead
 */ export var uniqueId = function(prefix) {
    var id = ++idCounter;
    return "".concat(prefix).concat(id);
};
export var disposePreviousCounter = function() {
    idCounter = 0;
};
